// src/pages/hair-transplant/hair-transplant.component.jsx
import React, { useState } from 'react';
import './hair-transplant.styles.scss';

// Import images
import tr1 from '../../components/pic/transplant/tr1.png';
import tr2 from '../../components/pic/transplant/tr2.png';
import tr3 from '../../components/pic/transplant/tr3.png';

const HairTransplant = () => {
  const whatsappLink = "https://wa.me/923224314712";
  
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    location: '',
    serviceType: 'hair-transplant',
    appointmentDate: '',
    appointmentTime: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const serviceTypeMap = {
      'hair-transplant': 'Hair Transplant',
      'hair-patch': 'Hair Patch',
      'consultation': 'Free Consultation'
    };

    const message = `🦁 CRISPY HAIR SOLUTION - APPOINTMENT REQUEST
    ━━━━━━━━━━━━━━━━━━━━━━━━━
    📋 New Appointment Booking
    ─────────────────────────
    👤 Name: ${formData.name}
    📱 Phone: ${formData.phone}
    📍 Location: ${formData.location}
    🏥 Service: ${serviceTypeMap[formData.serviceType] || formData.serviceType}
    📅 Date: ${formData.appointmentDate || 'Not specified'}
    ⏰ Time: ${formData.appointmentTime || 'Not specified'}
    📝 Message: ${formData.message || 'No additional message'}
    ━━━━━━━━━━━━━━━━━━━━━━━━━
    Please confirm this appointment.`;

    const encodedMessage = encodeURIComponent(message);
    window.open(`${whatsappLink}?text=${encodedMessage}`, '_blank');
    
    setIsSubmitting(false);
    setShowSuccess(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setFormData({
        name: '',
        phone: '',
        location: '',
        serviceType: 'hair-transplant',
        appointmentDate: '',
        appointmentTime: '',
        message: ''
      });
      setShowSuccess(false);
    }, 5000);
  };

  const images = [
    { src: tr1, alt: 'Hair Transplant Procedure 1' },
    { src: tr2, alt: 'Hair Transplant Procedure 2' },
    { src: tr3, alt: 'Hair Transplant Procedure 3' }
  ];

  return (
    <div className="hair-transplant-page">
      {/* ===== HERO SECTION ===== */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Surgical Hair Transplant</h1>
          <p>Advanced surgical solutions for permanent hair restoration in Pakistan</p>
          <div className="hero-badges">
            <span className="badge">✅ FUE & FUT Techniques</span>
            <span className="badge">✅ 100% Natural Results</span>
            <span className="badge">✅ Experienced Surgeons</span>
          </div>
        </div>
      </section>

      {/* ===== IMAGES GALLERY ===== */}
      <section className="gallery-section">
        <h2>Our Hair Transplant Gallery</h2>
        <p>See the results of our successful hair transplant procedures</p>
        <div className="gallery-grid">
          {images.map((image, index) => (
            <div className="gallery-item" key={index}>
              <img src={image.src} alt={image.alt} />
              <div className="gallery-overlay">
                <span>View Procedure</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ===== SERVICES SECTION ===== */}
      <section className="services-section">
        <h2>Our Hair Transplant Services</h2>
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">💉</div>
            <h3>FUE Hair Transplant</h3>
            <p>Follicular Unit Extraction - No scarring, faster recovery, natural results</p>
            <ul>
              <li>✓ No visible scarring</li>
              <li>✓ Quick recovery time</li>
              <li>✓ Natural-looking results</li>
              <li>✓ Minimal discomfort</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-icon">🔬</div>
            <h3>FUT Hair Transplant</h3>
            <p>Follicular Unit Transplantation - Maximum grafts for better density</p>
            <ul>
              <li>✓ Maximum graft yield</li>
              <li>✓ Cost-effective solution</li>
              <li>✓ Proven technique</li>
              <li>✓ Excellent for large areas</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-icon">🏆</div>
            <h3>Why Choose Us?</h3>
            <p>Expert care with state-of-the-art technology and affordable packages</p>
            <ul>
              <li>✓ Experienced surgeons</li>
              <li>✓ State-of-the-art technology</li>
              <li>✓ 100% natural results</li>
              <li>✓ Affordable packages</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ===== BOOKING FORM SECTION ===== */}
      <section className="booking-section">
        <div className="booking-container">
          <div className="booking-header">
            <h2>📋 Book Your Appointment</h2>
            <p>Fill in your details and we'll confirm your appointment</p>
          </div>

          {showSuccess && (
            <div className="success-message">
              <span>✅</span>
              <div>
                <h4>Appointment Request Sent!</h4>
                <p>We will contact you shortly on WhatsApp.</p>
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit} className="booking-form">
            <div className="form-row">
              <div className="form-group">
                <label>👤 Full Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your full name"
                  required
                />
              </div>

              <div className="form-group">
                <label>📱 Phone Number *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter your phone number"
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>📍 Location</label>
                <input
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  placeholder="Enter your city/location"
                />
              </div>

              <div className="form-group">
                <label>🏥 Service Type *</label>
                <select
                  name="serviceType"
                  value={formData.serviceType}
                  onChange={handleChange}
                  required
                >
                  <option value="hair-transplant">Hair Transplant</option>
                  <option value="hair-patch">Hair Patch</option>
                  <option value="consultation">Free Consultation</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>📅 Appointment Date</label>
                <input
                  type="date"
                  name="appointmentDate"
                  value={formData.appointmentDate}
                  onChange={handleChange}
                  min={new Date().toISOString().split('T')[0]}
                />
              </div>

              <div className="form-group">
                <label>⏰ Preferred Time</label>
                <select
                  name="appointmentTime"
                  value={formData.appointmentTime}
                  onChange={handleChange}
                >
                  <option value="">Select time</option>
                  <option value="09:00 AM">09:00 AM</option>
                  <option value="10:00 AM">10:00 AM</option>
                  <option value="11:00 AM">11:00 AM</option>
                  <option value="12:00 PM">12:00 PM</option>
                  <option value="01:00 PM">01:00 PM</option>
                  <option value="02:00 PM">02:00 PM</option>
                  <option value="03:00 PM">03:00 PM</option>
                  <option value="04:00 PM">04:00 PM</option>
                  <option value="05:00 PM">05:00 PM</option>
                  <option value="06:00 PM">06:00 PM</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label>📝 Additional Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Any additional details or questions..."
                rows="3"
              />
            </div>

            <button 
              type="submit" 
              className="submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : '📤 Send Appointment Request'}
            </button>
          </form>
        </div>
      </section>

      {/* ===== CTA SECTION ===== */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Ready for a New Look?</h2>
          <p>Book your consultation today and take the first step towards hair restoration</p>
          <div className="cta-buttons">
            <a href="#booking" className="cta-primary">
              📅 Book Appointment
            </a>
            <a 
              href={whatsappLink} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="cta-secondary"
            >
              💬 Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HairTransplant;